import { gql } from "@apollo/client";

const ANULAR_VISITA = gql`
mutation AnularVisita($idVisita: Int!, $observacion: String!){
    anularVisita(idVisita: $idVisita, observacion: $observacion)
}`;

export default ANULAR_VISITA;